module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/divider/divider.component.scss
// module id = ./src/app/features/divider/divider.component.scss
// module chunks = main